import styled, { keyframes } from 'styled-components';

const ring = keyframes`
    0% {
        transform: rotate(0.1deg);
    }
    15% {
        transform: rotate(-0.2deg);
    }
    30% {
        transform: rotate(0.2deg);
    }
    45% {
        transform: rotate(-0.2deg);
    }
    60% {
        transform: rotate(0.2deg);
    }
    75% {
        transform: rotate(-0.1deg);
    }
    100% {
        transform: rotate(0deg);
    }
`;

export const AnimatedPath = styled.path<{ $fill: string }>`
  cursor: pointer;

  fill: ${({ $fill }) => $fill};

  transform-origin: bottom center;
  animation: ${ring} 0.7s forwards;
  animation-iteration-count: 1;

  &:hover {
    animation: ${ring} 0.7s forwards;
    animation-iteration-count: 1;
  }
`;
